import { Menu, Item, useContextMenu } from 'react-contexify'

export default function ({ store, theme, location, navigator }) {
  const { show } = useContextMenu({
    id: 'lytwflmmy8'
  })

  const handleClick = ({ id, props }: any) => {
    if (id == 'other') {
      store.history.dispatch(
        store.history.data.filter(elm => elm.url == props.focus.url)
      )
    }

    else if (id == 'left') {
      store.history.dispatch(
        store.history.data.slice(store.history.data.findIndex(elm => elm.url == props.focus.url))
      )
    }

    else {
      store.history.dispatch(
        store.history.data.slice(0, store.history.data.findIndex(elm => elm.url == props.focus.url) + 1)
      )
    }
  }

  const options = React.useMemo(() => [
    {
      id: 'other',
      title: '关闭其他标签页',
      icon: 'fa-exchange',
    },
    {
      id: 'left',
      title: '关闭左侧标签页',
      icon: 'fa-arrow-left',
    },
    {
      id: 'right',
      title: '关闭右侧标签页',
      icon: 'fa-arrow-right',
    },
  ], [])

  return <div className='bg-white shadow pt-3 px-4'>
    <ul className='flex items-center space-x-2 justify-start flex-wrap'>
      {store.history.data.map(data => {
        return <li
          key={data.url}
          onContextMenu={(e) => show({ event:e, props: { focus: data } })}
          className={`mb-2 transition duration-300 ease-in-out cursor-pointer flex items-center space-x-2 px-2 py-1 text-sm border text-center min-w-[80px] ${location.pathname == data.url.split('?').shift() ? 'bg-[#ffd591] border-[#ffd591] text-white' : 'border-gray-200 text-gray-500'}`}
          onClick={() => navigator.to(data.url, data.title)}
        >
          <div>{data.title}</div>

          {store.history.data.length == 1 ? null : (
            <div onClick={e => [ e.stopPropagation(), store.history.del(data.url), location.pathname == data.url.split('?').shift() ? navigator.back() : null ]}>
              <i className={`fa fa-times text-xs hover:text-red-400 transition-color duration-300 ease-in-out ${location.pathname == data.url.split('?').shift() ? 'text-white' : 'text-gray-300'}`}/>
            </div>
          )}
        </li>
      })}
    </ul>

    <Menu id='lytwflmmy8' animation='fade'>
      {options.map(data => {
        return <Item
          id={data.id}
          onClick={e => [ navigator.replace(e.props.focus.url, e.props.focus.title), handleClick(e) ]}
        >
          <i className={`fa ${data.icon} text-lg mr-2`}/>{data.title}
        </Item>
      })}
    </Menu>
  </div>
}
